export const dropdown = [
    {value: 'Acknowledged No Deposit', label: 'Acknowledged No Deposit'}
]